<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container px-4 px-lg-5">
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
      (click)="showMenu()"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      [ngClass]="{ show: menuVisible }"
      class="collapse navbar-collapse animate__animated animate__fadeIn"
    >
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-4">
        <li class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            routerLink="/home"
            routerLinkActive="active"
            >Home</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            routerLink="/plp"
            routerLinkActive="active"
            >Products</a
          >
        </li>
        <li *ngIf="!(isLoggedIn$ | async)" class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            routerLink="login"
            routerLinkActive="active"
            >Login</a
          >
        </li>
        <li *ngIf="!(isLoggedIn$ | async)" class="nav-item">
          <a
            class="nav-link"
            aria-current="page"
            routerLink="register"
            routerLinkActive="active"
            >Register</a
          >
        </li>
      </ul>
      <div class="d-flex user-menu-container">
        <button
          class="btn btn-outline-dark"
          type="button"
          routerLink="/my-account"
        >
          <i class="bi bi-person-circle"></i
          ><span [ngClass]="{ 'ps-2': (user$ | async) }">{{
            user$ | async
          }}</span>
        </button>
        <button class="btn btn-outline-dark" type="button" routerLink="/cart">
          <i class="bi-cart-fill me-1"></i>
          Cart
          <span class="badge bg-dark text-white ms-1 rounded-pill">{{
            cartProductsLength$ | async
          }}</span>
        </button>
      </div>
    </div>
  </div>
</nav>
